export const tokens = {
  primary:         "#FF5A5F",
  primaryDark:     "#e04e52",
  primaryDeep:     "#c13333",
  primaryLight:    "#ff8a8d",
  primaryMuted:    "#c9444a",
  success:         "#16a34a",
  warn:            "#f59e0b",
  danger:          "#dc2626",
  dangerDeep:      "#b91c1c",
  textPrimary:     "#1a1a2e",
  textSecondary:   "#4a4a68",
  textMuted:       "#6b6b82",
  textMutedSoft:   "#868686",
  textPlaceholder: "#aaaaaa",
  textDisabled:    "#cccccc",
};
